import React from "react";
import "../style/CylinderModal.css";

const CylinderModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  setFormData,
  isEditing,
}) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        
        <div className="modal-header">
          <h3 className="modal-title">
            {isEditing ? "Edit Cylinder" : "Add New Cylinder"}
          </h3>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>

          <div className="form-grid">

            <div className="form-group">
              <label className="form-label">Cylinder Name</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter cylinder name"
                value={formData.cylinderName}
                onChange={(e) =>
                  handleChange("cylinderName", e.target.value)
                }
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Batch No</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter batch number"
                value={formData.batchNo}
                onChange={(e) => handleChange("batchNo", e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">SR No</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter SR number"
                value={formData.srno}
                onChange={(e) => handleChange("srno", e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Manufacturing Date</label>
              <input
                type="date"
                className="form-input"
                value={formData.manufacturingDate}
                onChange={(e) =>
                  handleChange("manufacturingDate", e.target.value)
                }
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Testing Date</label>
              <input
                type="date"
                className="form-input"
                value={formData.testingDate}
                onChange={(e) =>
                  handleChange("testingDate", e.target.value)
                }
                required
              />
            </div>

            <div className="form-group full-width">
              <label className="form-label">Capacity</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter capacity"
                value={formData.cylinderCapacity}
                onChange={(e) =>
                  handleChange("cylinderCapacity", e.target.value)
                }
                required
              />
            </div>

          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" type="submit">
              {isEditing ? "Update" : "Add"} Cylinder
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default CylinderModal;